<app-header></app-header>

<div class="container-fluid" style="width: 80%">

    <div class="row mt-4 mb-4">
        <div class="col">
            <nav class="breadcrumb-container" aria-label="Percorso di navigazione">
                <ol class="breadcrumb mb-0 p-0">
                    <li class="breadcrumb-item"><a href="/home">Home</a><span class="separator">/</span></li>
                    <li class="breadcrumb-item active" aria-current="page">Cruscotto statistiche</li>
                </ol>
            </nav>
        </div>
    </div>

    <div class="row mt-4 mb-4">
        <div class="col">
            <h4>Cruscotto statistiche</h4>
        </div>
    </div>

    <mat-card class="p-2" appearance="outlined">

        <mat-card-content>

            <p><b>Richieste totali: </b> {{statistiche.totaleRichieste}}</p>

            <mat-chip-set aria-label="Richieste per stato">
                <ng-container *ngIf="!caricamento">
                    @for (stato of stati; track stato.id) {
                    <mat-chip>
                        {{stato.descrizione}}: <b>{{numeroRichiestePerStato(stato)}}</b>
                    </mat-chip>
                    }
                </ng-container>
            </mat-chip-set>

            <hr>

            <mat-list>
                <mat-list-item>
                    <mat-icon matListItemIcon>person</mat-icon>
                    <div matListItemTitle>Pazienti totali: {{statistiche.totalePazienti}}</div>
                </mat-list-item>
                <mat-list-item>
                    <mat-icon style="color: blueviolet" matListItemIcon>male</mat-icon>
                    <div matListItemTitle>Pazienti maschi: {{statistiche.totalePazientiMaschi}}</div>
                </mat-list-item>
                <mat-list-item>
                    <mat-icon style="color: rgb(255, 0, 98)" color matListItemIcon>female</mat-icon>
                    <div matListItemTitle>Pazienti femmine: {{statistiche.totalePazientiFemmine}}</div>
                </mat-list-item>
            </mat-list>

        </mat-card-content>

    </mat-card>

</div>

<app-footer></app-footer>